export default __webpack_public_path__ + "static/media/star_4.25d4c936.svg";